import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import adminOffersApi from "./api/adminOffersApi";
import { AdminOffersQuery, AdminOffersQueryParameter, AdminOffersState } from "./models/AdminOffersModels";

export const getOffers = createAsyncThunk(
  "adminOffers/getOffers",
  async (query: AdminOffersQuery) => {
    return adminOffersApi.getOffers(query);
  }
);

export const getOffer = createAsyncThunk(
  "adminOffers/getOffer",
  async (id: string) => {
    return adminOffersApi.getOffer(id);
  }
);

export const getOfferDocument = createAsyncThunk(
  "adminOffers/getOfferDocument",
  async (id: string) => {
    return adminOffersApi.getOfferDocument(id);
  }
);

export const deleteOffer = createAsyncThunk(
  "adminOffers/deleteOffer",
  async (id: string) => {
    return adminOffersApi.deleteOffer(id);
  }
);

const initialState: AdminOffersState = {
  query: {
    search: undefined,
    sortBy: AdminOffersQueryParameter.createdDate,
    sortDesc: true,
    pageNo: 1,
    pageSize: 20
  },
  offers: undefined,
  offer: undefined,
  loading: false,
  success: undefined,
  error: undefined,
};

const adminOffersSlice = createSlice({
  name: "adminOffers",
  initialState: initialState,
  reducers: {
    changeQuery: (state, { payload }) => {
      state.query = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getOffers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOffers.fulfilled, (state, { payload }) => {
        state.offers = payload;
        state.loading = false;
      })
      .addCase(getOffers.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOffer.fulfilled, (state, { payload }) => {
        state.offer = payload;
        state.loading = false;
      })
      .addCase(getOffer.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getOfferDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOfferDocument.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(getOfferDocument.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(deleteOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteOffer.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(deleteOffer.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });
  }
});

export const {
  changeQuery,
  setLoading,
  setSuccess,
  setError
} = adminOffersSlice.actions;

export default adminOffersSlice.reducer;